import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";
import _ from "lodash";

export interface Game {
    id?: number;
    name: string;
    type: number;
    software_house: { name: string, id: number };
    image: string;
    deprecated?: boolean;
    game_type: any;
    client: any;
    feature: any;
    trademark: any;
    series: any;
    platform: any;

}

export function games(
    state: { results: Game[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_GAMES_SUCCESS:
            return action.payload.games;

        default:
            return state;
    }
}

export function gamesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_GAMES:
            return true;

        case GamesActionTypes.GET_GAMES_FAIL:
        case GamesActionTypes.GET_GAMES_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function gamesBySubsidiary(state: Game[] = [], action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS_SUCCESS:
            return _.uniqBy(
                action.payload.configurations["results"],
                "game"
            ).map(configuration => {
                return configuration.game;
            });
        default:
            return state;
    }
}

export function gamesBySubsidiaryLoading(
    state: boolean = true,
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS:
            return true;

        case GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS_FAIL:
        case GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function searchGamesLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case GamesActionTypes.SEARCH_GAMES:
            return true;
        case GamesActionTypes.SEARCH_GAMES_FAIL:
        case GamesActionTypes.SEARCH_GAMES_SUCCESS:
            return false;
        default:
            return state;
    }
}

export function searchGames(state: [] = [], action: Action) {
    switch (action.type) {
        case GamesActionTypes.CLEAR_SEARCH_GAMES:
            return [];
        case GamesActionTypes.SEARCH_GAMES_SUCCESS:
            return action.payload.games.results;
        default:
            return state;
    }
}
